import BaseService from "@/services/BaseService";

export default class CoverageCarrierService extends BaseService {
  constructor() {
    super("odoo/coverage");
  }

  findAllByCoverageId(coverageId, data) {
    return this.http.get(`${this._serviceName}/${coverageId}/carriers`, {
      params: data,
    });
  }

  save(coverageId, data) {
    return this.http.post(
      `${this._serviceName}/${coverageId}/carriers`,
      data
    );
  }

  delete(coverageCarrierId) {
    return this.http.delete(
      `${this._serviceName}/coverage-carrier/${coverageCarrierId}`
    );
  }

  update(id, descriptionId) {
    return this.http.put(`${this._serviceName}/coverage-carrier/${id}/description/${descriptionId}`)
  }
}
